module.exports = __webpack_public_path__ + "static/media/andrew@2x.48b92bcc.png";